<template>
  <div id="admin">
    <menu-admin />
    <section class="int-form" style="margin-top: 30px;">
      <div class="container">
        <div class="text-right d-print-none action-badges">
          <a
            id="changeClient"
            class="badge badge-info"
            href="#"
            style="color: white !important;"
            data-toggle="modal"
            data-target="#clientsModal"
          >
            <i class="fa fa-user" aria-hidden="true"></i> Alterar cliente
          </a>
          <a
            id="changeDate"
            class="badge badge-info"
            href="#"
            style="color: white !important;"
            data-toggle="modal"
            data-target="#datesModal"
          >
            <i class="fa fa-calendar" aria-hidden="true"></i> Alterar datas
          </a>
          <a
            class="badge badge-info"
            href="javascript:window.print();"
            style="color: white !important;"
          >
            <i class="fa fa-print" aria-hidden="true"></i> Imprimir
          </a>
        </div>
        <!-- Modal -->
        <div
          class="modal fade"
          id="clientsModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="clientsModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="clientsModalLabel">Alterar cliente</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row form-group">
                  <div class="col-12">
                    <label>Selecione um cliente:</label>
                    <v-select
                      :filterable="false"
                      v-model="client_selected"
                      :options="client_options"
                      @search="client_search"
                    >
                      <div slot="no-options">Nenhuma publicação encontrada!</div>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" @click="changeDate()" class="btn btn-primary">Pesquisar</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal -->
        <div
          class="modal fade"
          id="datesModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="datesModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="datesModalLabel">Informe o intervalo de datas</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row form-group">
                  <div class="col-6">
                    <label>Data de início:</label>
                    <datepicker
                      input-class="form-control"
                      name="dates"
                      v-model="start_date"
                      :format="customFormatter"
                    ></datepicker>
                  </div>
                  <div class="col-6">
                    <label>Data final:</label>
                    <datepicker
                      input-class="form-control"
                      v-model="end_date"
                      :format="customFormatter"
                    ></datepicker>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" @click="changeDate()" class="btn btn-primary">Pesquisar</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 title-report">
          <h5>
            Expedições
            <i
              v-if="start_date && end_date"
            >entre {{ start_date_formated }} e {{ end_date_formated }}</i>
          </h5>
          <br />

          <table
            class="table table-bordered table-sm table-hover"
            style="background: white; font-size: 0.8em"
          >
            <tr v-show="!expeditions.length">
              <td class="text-center" colspan="4">Nenhuma expedição encontrada</td>
            </tr>
            <thead v-show="expeditions.length">
              <tr>
                <th class="text-center" width="100" scope="col">Data Pedido</th>
                <th class="text-center">N Pedido</th>
                <th>Cliente</th>
                <th>Publicação</th>
                <th class="text-center">Prefixo</th>
                <th class="text-center">Data Expedição</th>
                <th class="text-center">Cod Rastreio</th>
              </tr>
            </thead>
            <tbody v-show="expeditions.length">
              <tr v-for="expedition in expeditions" v-bind:key="expedition.id">
                <td class="text-center">{{ expedition.order.date | formatDate }}</td>
                <td class="text-center">#{{expedition.order.id}}</td>
                <td>
                  <span
                    v-if="expedition.profile.person_or_company"
                  >{{expedition.profile.company_name}}</span>
                  <span v-else>{{expedition.profile.name}}</span>
                </td>
                <td>{{expedition.publication.name}}</td>
                <td class="text-center">{{expedition.airplane_prefix}}</td>
                <td class="text-center">{{ expedition.expedition_date | formatDate }}</td>
                <td class="text-center">{{expedition.track_code}}</td>
              </tr>
              <tr v-show="!expeditions.length">
                <td colspan="5" class="text-center">Nenhum resultado pode ser encontrado</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
    <footer-admin />
  </div>
</template>

<script>
import menuAdmin from "../admin/common/menu-admin";
import user from "../../api/user";
import footerAdmin from "../admin/common/footer-admin";
import mixins from "../../helpers/mixins";
import reports from "../../api/reports";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  name: "ExpeditionList",
  mixins: [mixins],
  data() {
    return {
      client_selected: {},
      client_options: [],
      expeditions: {},
      start_date: "",
      end_date: "",
    };
  },
  components: { menuAdmin, footerAdmin, Datepicker },
  methods: {
    client_search(search, loading) {
      loading(true);
      user.list(1, search).then((response) => {
        let clients = response.data.results;

        let options = [];
        clients.forEach(function (item) {
          let name = item.name;
          if (item.person_or_company) {
            name = item.company_name;
          }

          options.push({
            label: name,
            id: item.id,
          });
        });
        this.client_options = options;
        loading(false);
      });
    },
    getExpeditions(start, end) {
      start = moment(this.start_date).format("YYYY-MM-DD");
      end = moment(this.end_date).format("YYYY-MM-DD");
      let client = null;

      console.log(JSON.stringify(this.client_selected));
      if (
        JSON.stringify(this.client_selected) !== "{}" &&
        this.client_selected !== null
      )
        client = this.client_selected.id;

      reports
        .expedition_list(start, end, client)
        .then((response) => {
          this.expeditions = response.data;

          $("#datesModal").modal("hide");
          $("#clientsModal").modal("hide");
        })
        .catch((errors) => {
          this.formErrors(errors);
        });
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    changeDate() {
      this.getExpeditions();
    },
  },
  computed: {
    start_date_formated: function () {
      return moment(this.start_date).format("DD/MM/YYYY");
    },
    end_date_formated: function () {
      return moment(this.end_date).format("DD/MM/YYYY");
    },
  },
  mounted() {
    this.start_date = new Date(
      moment().subtract(30, "days").format("YYYY-MM-DD")
    );
    this.end_date = new Date();
    this.getExpeditions();
  },
};
</script>

<style scoped>
.action-badges {
  margin-top: 80px;
  padding-top: 10px;
  z-index: 1;
  position: relative;
}

.title-report {
  margin-top: -20px;
}

@media screen and (max-width: 999px) {
  .action-badges {
    margin-top: 100px;
    padding-top: 0px;
    padding-bottom: 10px;
    z-index: 1;
    position: relative;
  }

  .title-report {
    margin-top: 0;
  }
}
</style>